'use client';

// Error components must be Client Components
// https://nextjs.org/docs/app/building-your-application/routing/error-handling

import { useEffect } from 'react';
import { ErrorPageHeader } from '@components/v3/organisms/error-page-header';
import Image from 'next/image';
import styles from '@styles/error.module.scss';
import classnames from 'classnames';

export default function Error({
  error,
  // reset,
}: {
  error: Error & { digest?: string };
  // reset: () => void;
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error);
  }, [error]);

  return (
    <ErrorPageHeader
      classNames={[classnames(styles.error)]}
      title="Internal server error"
      subTitle="Sorry there was an error on our side."
      error="500 Error"
      image={<Image src="/images/error/error500-2.jpg" alt="500 Error" fill />}
    />
  );
}
